import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient, apiErrorMessage } from "../api/client";
import type { SignedIn } from "../lib/auth";
import { campaignPath } from "../lib/campaign";
import { Spinner } from "../components/Spinner";

/* A past run's old address, /runs/<id>, sent to that list on its campaign's
 * page. A run is a list now, and the List tab shows a past one at ?list=
 * (docs/plans/campaigns-overhaul.md). Links to /runs/ exist in exports and
 * notes, so the address keeps working. */
export function CampaignRunView({ session }: { session: SignedIn }) {
  const { runId } = useParams();
  const run = useQuery({
    queryKey: ["run-campaign", runId],
    enabled: Boolean(runId),
    queryFn: async () => {
      const { data, error } = await apiClient(session.idToken).from("campaign_run")
        .select("id,criteria_set_name").eq("id", runId as string).limit(1);
      if (error) throw new Error(apiErrorMessage(error));
      return ((data ?? [])[0] ?? null) as { id: string | null; criteria_set_name: string | null } | null;
    },
  });
  if (run.isLoading) return <main><p className="muted"><Spinner />Finding the list.</p></main>;
  if (run.isError) return <main><p className="refusal">{(run.error as Error).message}</p></main>;
  if (!run.data?.criteria_set_name) return <main><p className="refusal">No list has this address.</p></main>;
  return <Navigate to={`${campaignPath(run.data.criteria_set_name)}?list=${run.data.id}`} replace />;
}
